export enum FiledType {
    Password = 'password',
    TextArea = 'textarea',
    File = 'file',
    String = 'string',
    List = 'list',
    CheckBox = 'checkbox',
    Number = "number",
    package = "package",
    Assets = "assets",
}

export interface IVarPrompt {
    name: string,
    label: string,
    type: string,
    type_options: Array<string>,
    help?: string,
    helpLink?: string,
    required: boolean,
    default: any,
    private: boolean,
    lookup_handler?: string,
    lookup_label?: string,
    choices: Array<IChoice>
}

export interface IChoice {
    name: string,
    label: string,
}

export interface IMeta {
    template: string,
    name: string,
    vars_prompt: Array<IVarPrompt>
}

export interface IFile {
    id: number,
    guid: string
    name: string
    size: number
    mime?: string
    package?: string
    url?: string
    repository_name?: string
}

export interface IPackageFormat {
    value: string;
    label: string;
}

export interface IPackageFormatGroup {
    group: string;
    formats: IPackageFormat[];
}

export interface IPackageFormatsResponse {
    package_formats: IPackageFormatGroup[];
}

export interface IPolicy {
    id?: number,
    name: string,
    template: string,
    show_on_portal: boolean,
    auto_execute: boolean,
    show_in_app_store: boolean,
    app_name?: string,
    app_description?: string,
    app_icon?: IFile,
    file?: IFile,
    vars: Record<string, any>,
    os_name: string,
    app_store_package_format?: string,
    app_store_windows_architecture?: string,
    app_category?: number,
}

export interface IPolicyCategoryInfo {
    id: number,
    name: string,
}

export interface IUserTemplateCategory {
    selectedCategory?: string,
    inputtedCategory?: string
}

export interface ITemplate {
    id: string,
    name: string,
    yaml: string,
    system: boolean
    changed?: boolean
}

export interface IErrors {
    ok: boolean,
    categoryError?: Error,
    parseError?: Error,
    apiError?: Error,
    fields: Record<string, string>
}

export interface ILdapNode {
    id?: string,
    server_id?: string
    cn: string,
    dn: string,
    leaf: boolean;
    icon: string;
    readonly?: boolean;
    page?: number,
    entity?: string;
    url?: string;
    attrs: { [key: string]: any },
    menu?: string;
    selectedDn?: string
    member_group: string[]
}
